/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GrantedAuthority } from './GrantedAuthority';
export type UserPrincipal = {
    uuid?: string;
    accountId?: number;
    username?: string;
    password?: string;
    name?: string;
    email?: string;
    roles?: Array<string>;
    expiredAt?: number;
    storeCode?: string;
    storeName?: string;
    authority?: UserPrincipal.authority;
    organization?: UserPrincipal.organization;
    srcIfNo?: string;
    allowChangeRequestWithoutValidation?: boolean;
    enabled?: boolean;
    credentialsNonExpired?: boolean;
    west?: boolean;
    manager?: boolean;
    editor?: boolean;
    admin?: boolean;
    headquarter?: boolean;
    storeUser?: boolean;
    authorities?: Array<GrantedAuthority>;
    accountNonExpired?: boolean;
    accountNonLocked?: boolean;
    itHeadquarter?: boolean;
};
export namespace UserPrincipal {
    export enum authority {
        ADMIN = 'ADMIN',
        MANAGER = 'MANAGER',
        EDITOR = 'EDITOR',
    }
    export enum organization {
        STORE = 'STORE',
        HEADQUARTERS = 'HEADQUARTERS',
        IT_HEADQUARTERS = 'IT_HEADQUARTERS',
        GROCERY_HEADQUARTERS = 'GROCERY_HEADQUARTERS',
    }
}

